import React, { useState, useEffect } from "react";
import { Box, TextField, Typography } from "@mui/material";
import {
  cardOutline,
  semiBoldFonts,
  textFieldStyles,
} from "../../../Styles/Styles";

const Search = ({ onFilterChange, defaultQuery = "" }) => {
  const [query, setQuery] = useState(defaultQuery);

  useEffect(() => {
    setQuery(defaultQuery || "");
  }, [defaultQuery]);

  const handleQueryChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    onFilterChange({ query: value }); // Pass search query to parent
  };

  return (
    <Box
      sx={{
        p: 2,
        mb: 2,
        borderRadius: "8px",
        ...cardOutline,
      }}
    >
      <Typography variant="h6" gutterBottom sx={{ mb: 2, ...semiBoldFonts }}>
        Search
      </Typography>
      <TextField
        label="I'm looking for..."
        type="text"
        value={query}
        onChange={handleQueryChange}
        variant="outlined"
        fullWidth
        sx={{ ...textFieldStyles }}
      />
    </Box>
  );
};

export default Search;
